import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.regexp.match.js";
export var clearCaches = function clearCaches() {
  var urls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SW_PRECACHE';
  var key = "".concat(prefix, "-runtime-").concat(window.location.origin, "/");
  return new Promise(function (resolve) {
    window.caches.open(key).then(function (cache) {
      cache.keys().then(function (keys) {
        keys.forEach(function (request, i) {
          if (urls.find(function (url) {
            return request.url.match(url);
          })) {
            cache.delete(request);
          }

          if (i + 1 === keys.length) {
            resolve();
          }
        });
      });
    });
  });
};
export var precacheUrls = function precacheUrls(urls) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SW_PRECACHE';
  var key = "".concat(prefix, "-runtime-").concat(window.location.origin, "/");
  return new Promise(function (resolve) {
    window.caches.open(key).then(function (cache) {
      cache.addAll(urls); // urls.forEach((url) => {
      //   cache.addAll(urls); // Preferred: Requires CORS configuration on the CDN
      //   // Alternative: Cache response even if opaque - risks caching errors returned by server
      //   // const request = new Request(url, { mode: 'no-cors' })
      //   // fetch(request).then(response => cache.put(request, response))
      // });

      resolve();
    });
  });
};